import { api } from "./api";
import ShowNotifications from "../helper/ShowNotifications";

class GalleryApi {
  getGalleryByExpo = async (expoId) => {
    try {
      const response = await api.get(`/gallery/${expoId}`);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      return { status: false, response: error?.response?.data || error };
    }
  };

  saveGallery = async (data) => {
    try {
      const response = await api.post("/gallery/save", data);
      if (response.status === 200 || response.status === 201) {
        ShowNotifications.showAlertNotification("Gallery Saved Successfully", true);
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Failed to save gallery";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };
}

const galleryApi = new GalleryApi();
export default galleryApi;

export const {
  getGalleryByExpo,
  saveGallery,
} = galleryApi;
